module.exports = __webpack_public_path__ + "static/media/grid.8ffab2f3.svg";